export const RPC_URL: string = 'https://solana-mainnet.g.alchemy.com/v2/alch_uyX9mmUpMIj_GBJ5RUL-g';

export const ATTRIBUTES_PER_PAGE: number = 6;
